import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__collection_image_delete } from '@shared/dto/collection/_requests/DTO_REQUEST__collection_image_delete';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__collections } from '../STATE__collections';

export const REMOTE__collection_cells_delete = createAsyncThunkSafe<void, DTO_REQUEST__collection_image_delete[]>(
  ENUM__network_event_client_to_server.COLLECTION__IMAGE_DELETE,
  async (items: DTO_REQUEST__collection_image_delete[]): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.COLLECTION__IMAGE_DELETE, items);
  },
);

export function INIT_REMOTE__collection_cells_delete(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(REMOTE__collection_cells_delete.pending, (state, action) => {})
    .addCase(REMOTE__collection_cells_delete.rejected, (state, action) => {})
    .addCase(REMOTE__collection_cells_delete.fulfilled, (state, action: PayloadAction) => {});
}
